



































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Action, State } from 'vuex-class';
import GenericFileUploader from '../../../components/uploader/GenericFileUploader.vue';
import { isTruthy } from '../../../jbi-shared/util/watcher.vue-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import {
  CreateGripEnablerBase,
  FileAttachmentDTO,
  GripEnablerDTO,
  GripDomainCategory,
  LinkDTO,
  UpdateGripEnablerPayload,
} from '../../../store/types/grip.types';
import { ApiState } from '../../../store/types/general.types';
import DomainCategoryDropdown from '../DomainCategory/DomainCategoryDropdown.vue';
import {
  getSourceLink,
  getWordCount,
  validateLink,
} from '../../../utils/general.util';
import InteractiveModal from '@/components/base/InteractiveModal.vue';
import GripModalMixin from '@/views/Grip/components/grip-modal.mixin';

@Component({
  components: { DomainCategoryDropdown, GenericFileUploader, InteractiveModal },
})
export default class EnablerModal extends mixins(GripModalMixin) {
  @Prop() public gripEnablerDetails!: GripEnablerDTO;

  /**
   * Fulfills the contract of the GripModalMixin by providing the `itemDetails` property.
   * This computed property maps the component-specific `gripEnablerDetails` prop
   * to the generic `itemDetails` property that the mixin expects.
   */
  public get itemDetails(): GripEnablerDTO | null {
    return this.gripEnablerDetails;
  }

  public dirtyItem: CreateGripEnablerBase = {
    title: '',
    description: '',
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };
  public itemLinks: LinkDTO[] = [];
  public errorMessage: {
    title: string | null;
    description: string | null;
  } = { title: null, description: null };

  public validateData() {
    if (!this.dirtyItem.title.trim().length) {
      this.errorMessage.title = 'This Field is Required';
    } else {
      this.errorMessage.title = null;
    }

    if (
      this.dirtyItem.description &&
      this.wordCount(this.dirtyItem.description.trim()) > 150
    ) {
      this.errorMessage.description = 'Max 150 words are allowed.';
    } else {
      this.errorMessage.description = null;
    }

    return this.errorMessage;
  }

  public onAddGripEnabler(): void {
    this.validateData();
    if (
      !this.errorMessage.title &&
      !this.errorMessage.description &&
      this.areLinksValid
    ) {
      this.getGripItemLinks();
      this.getItemAttachments();
      this.dirtyItem.gripDomainCategoryId = this.selectedGripDomainCategoryId;
      this.$emit('create', this.dirtyItem);
    }
  }

  public onUpdateGripEnabler(): void {
    this.getGripItemLinks();
    this.getItemAttachments();
    this.dirtyItem.gripDomainCategoryId = this.selectedGripDomainCategoryId;
    const enablerChanges: { [key: string]: any } = {};
    const currentEnablerData: { [key: string]: any } = {
      ...this.dirtyItem,
    };
    const originalEnablerDetails: { [key: string]: any } = {
      ...this.gripEnablerDetails,
    };
    Object.keys(currentEnablerData).forEach((key: string) => {
      if (key === 'gripDomainCategoryId') {
        const originalDomainCategoryId = originalEnablerDetails.gripDomainCategory
          ? originalEnablerDetails.gripDomainCategory.id
          : null;
        if (
          JSON.stringify(currentEnablerData.gripDomainCategoryId) !==
          JSON.stringify(originalDomainCategoryId)
        ) {
          enablerChanges.gripDomainCategoryId =
            currentEnablerData.gripDomainCategoryId;
        }
      } else {
        // Compare with originalEnablerDetails, not enablerInfo (which was a copy of gripEnablerDetails)
        if (
          JSON.stringify(currentEnablerData[key]) !==
          JSON.stringify(originalEnablerDetails[key])
        ) {
          enablerChanges[key] = currentEnablerData[key];
        }
      }
    });

    this.validateData();
    if (
      !this.errorMessage.title &&
      !this.errorMessage.description &&
      this.areLinksValid
    ) {
      // Always emit 'update' if validation passes.
      // EnablerSettings will check if Object.keys(enablerChanges).length > 0
      this.$emit('update', {
        id: this.gripEnablerDetails.id,
        ...enablerChanges, // This will be an empty object if no actual data changed
      });
    }
  }

  public mounted(): void {
    this.isDomainCategoriesLoading = true;
    this.getGripDomainCategories(this.projectId);
    if (
      this.gripEnablerDetails &&
      Object.keys(this.gripEnablerDetails).length > 0
    ) {
      const {
        gripDomainCategory,
        id,
        ...enablerInfo
      } = this.gripEnablerDetails;
      enablerInfo.links.forEach((link: string) => {
        this.count++;
        this.itemLinks.push({
          url: link,
          count: this.count,
          isValid: true,
          errorMessage: '',
        });
      });

      enablerInfo.attachments.forEach((file) => {
        const fileData = file.split('/');
        this.fileAttachment.push({
          type: file,
          name: fileData[fileData.length - 1],
        });
      });

      this.selectedGripDomainCategoryId = gripDomainCategory
        ? gripDomainCategory.id
        : null;

      this.dirtyItem = {
        ...enablerInfo,
        gripDomainCategoryId: this.selectedGripDomainCategoryId,
      };
    }

    this.setInitialFormState();
  }
}
